export const abrir = () => {
    window.open(window.TERMINOS_CONDICIONES, "_blank");
}